import { TFilterKey, TSortKey } from "@/interfaces";

import { IState } from "../state";

export class Alarms {
  static setAlarmsKeys(state: IState, keys: { sortKey: TSortKey; filterKeys: TFilterKey[] }) {
    const newState = Object.assign({}, state);
    newState.alarms = { ...keys };

    return newState;
  }
}
